import { classNames } from "../../UI/Utils/classNames.ts";
import { TEACHER_TIER_INFO, TeacherTier } from "./teacherTiers.ts";

export function TeacherTierBadge({
  tier,
  compact = false,
}: {
  tier: TeacherTier;
  compact?: boolean;
}) {
  const { rank, label, badgeClassName } = TEACHER_TIER_INFO[tier];
  return (
    <span
      title={compact ? label : undefined}
      className={classNames(
        "inline-flex w-fit items-center rounded-md px-2 py-0.5 text-xs font-medium whitespace-nowrap",
        badgeClassName,
      )}
    >
      Tier {rank}
      {!compact && ` · ${label}`}
    </span>
  );
}
